import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CommonModule, DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  AuthorizationService,
  BtCommonModule,
  BtMapModule,
  BtSearchModule,
  CanDeactivateGuard,
  CustomIconService,
  CustomReportsService,
  DeviceService,
  DialogService,
  ErrorService,
  InsightService,
  MessageService,
  MultiUserRoomService,
  OrganizationGuard,
  OrganizationSelectionService,
  OrganizationService,
  PlayService,
  RobotService,
  RoleGuard,
  StoreService,
  ThemeService,
  TimezoneService,
  TitleService,
  UserService
} from '@ng-cloud/badger-core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ActionCableService } from 'angular2-actioncable';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { HotkeyModule } from 'angular2-hotkeys';
import { LibLoginConfig, LibLoginInterceptor, LibLoginModule } from '@badgertechnologies/liblogin.js';
import { ThemeBuddyComponent } from './theme-buddy/theme-buddy/theme-buddy.component';
import { OrganizationDnaComponent } from './badger-dna/organization-dna/organization-dna.component';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { TranslateModule } from '@ngx-translate/core';
import { AppToastrModule } from '@ng-cloud/badger-core/toastr/toastr.module';

@NgModule({
  exports: [
    BrowserAnimationsModule,
    BtCommonModule,
    HotkeyModule
  ],
  declarations: [
    AppComponent,
    ThemeBuddyComponent,
    OrganizationDnaComponent
  ],
  bootstrap: [AppComponent], imports: [AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    BtCommonModule,
    BtMapModule,
    BtSearchModule,
    CommonModule,
    TranslateModule.forRoot(),
    AppToastrModule,
    HotkeyModule.forRoot({ cheatSheetCloseEsc: false }),
    {
      ngModule: LibLoginModule,
      providers: [
        {
          provide: LibLoginConfig, useValue: {
            fleet: environment.apiBase,
            ...environment.keycloak
          }
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: LibLoginInterceptor,
          multi: true
        }
      ]
    }], providers: [
    ActionCableService,
    AuthorizationService,
    CanDeactivateGuard,
    CustomIconService,
    CustomReportsService,
    DeviceService,
    DialogService,
    ErrorService,
    InsightService,
    MessageService,
    MultiUserRoomService,
    OrganizationGuard,
    OrganizationService,
    OrganizationSelectionService,
    PlayService,
    RobotService,
    RoleGuard,
    StoreService,
    TimezoneService,
    ThemeService,
    TitleService,
    UserService,
    DatePipe,
    ScrollingModule,
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    provideHttpClient(withInterceptorsFromDi(), withFetch())
  ]
})
export class AppModule {
}
